import React from 'react'

export default function GsgHeader() {
    return (
        <div className='py-20 bg-[#16A085]'>
            <div className='max-w-6xl mx-auto'>
                <p className='text-5xl font-bold text-center text-white py-8'>GSG Global Impact Summit 2021 – Speakers from Bangladesh</p>
            </div>
        </div>
    )
}
